import api from "../axiosInstance";

// Get all merchandise sales with pagination and filters
export const getAllMerchandiseSalesAPI = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.userId) queryParams.append("userId", params.userId);
    if (params.productId) queryParams.append("productId", params.productId);
    if (params.startDate) queryParams.append("startDate", params.startDate);
    if (params.endDate) queryParams.append("endDate", params.endDate);
    if (params.sortBy) queryParams.append("sortBy", params.sortBy);
    if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);

    const response = await api.get(
      process.env.REACT_APP_API_URL + `/api/v1/merchandise-sales?${queryParams}`
    );
    return response.data;
  } catch (e) {
    console.log("Error getting merchandise sales: " + e.message);
    throw e;
  }
};

// Get sales analytics
export const getMerchandiseSalesAnalyticsAPI = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append("startDate", params.startDate);
    if (params.endDate) queryParams.append("endDate", params.endDate);
    if (params.userId) queryParams.append("userId", params.userId);
    if (params.productId) queryParams.append("productId", params.productId);

    const response = await api.get(
      process.env.REACT_APP_API_URL +
        `/api/v1/merchandise-sales/analytics?${queryParams}`
    );
    return response.data;
  } catch (e) {
    console.log("Error getting sales analytics: " + e.message);
    throw e;
  }
};

// Get sales summary
export const getMerchandiseSalesSummaryAPI = async () => {
  try {
    const response = await api.get(
      process.env.REACT_APP_API_URL + "/api/v1/merchandise-sales/summary"
    );
    return response.data;
  } catch (e) {
    console.log("Error getting sales summary: " + e.message);
    throw e;
  }
};

// Export sales data
export const exportMerchandiseSalesAPI = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append("startDate", params.startDate);
    if (params.endDate) queryParams.append("endDate", params.endDate);
    if (params.userId) queryParams.append("userId", params.userId);
    if (params.productId) queryParams.append("productId", params.productId);

    const response = await api.get(
      process.env.REACT_APP_API_URL +
        `/api/v1/merchandise-sales/export?${queryParams}`
    );
    return response.data;
  } catch (e) {
    console.log("Error exporting sales data: " + e.message);
    throw e;
  }
};
